import { render, staticRenderFns } from "./homeDashboardTrainerStatistics.vue?vue&type=template&id=36149e5e&scoped=true"
import script from "./homeDashboardTrainerStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardTrainerStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardTrainerStatistics.vue?vue&type=style&index=0&id=36149e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36149e5e",
  null
  
)

export default component.exports